import withController from 'components/common/form-controlled/with-controller.hoc';
import BigCheckbox from 'components/common/input-components/big-checkbox';
import withLabel from './with-label.hoc';
import styled from 'types/theme.types';
import type { CheckboxProps } from 'antd';

const Checkbox = withLabel(
  withController<CheckboxProps>(BigCheckbox, {
    withoutRef: true,
    mapValueTo: 'checked',
    onChangeTransformer: e => e.target.checked
  })
);

/* No row height: a 28px row, sized for the old 20px box, pushed the 16px box off its label's centre
   (UI-polish review, "checkbox not aligned with text"). */
export const ControlledBigCheckbox = styled(Checkbox)``;

export default ControlledBigCheckbox;
